import React from 'react';
import CommentContainer from '../CommentContainer';

export default function CommentsList({
  listComments,
  deleteComent,
  onUpdateComment,
  onReplyComment,
  onForwardComment,
  email,
  protocolId,
  protocol,
  onRefresh
}) {
  const handleForwardComment = (isChecked) => {
    if (onForwardComment) {
      onForwardComment(isChecked);
    }
  };

  return (
    <div className="comments-list">
      {listComments.map((comment) => (
        <CommentContainer
          key={comment.id}
          id={comment.id}
          comment={comment}
          onDelete={() => deleteComent(comment.id)}
          onUpdate={(data) =>
            onUpdateComment && onUpdateComment(comment.id, data)
          }
          onReplyComment={onReplyComment}
          onForwardComment={handleForwardComment}
          email={email}
          protocolId={protocolId}
          protocol={protocol}
          onRefresh={onRefresh}
        />
      ))}
    </div>
  );
}
